import { useEffect, useState } from "react";
import { setMainLoading, setPageTitle } from "../../../Store/reducers/Common";
import { useDispatch, useSelector } from "react-redux";
import { PostAxios, responseCatchFunc } from "../../../Services/RequestService";

const OrgMaster = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 20 });
    const [orgList, setOrgList] = useState([]);
    useEffect(() => {
        dispatch(setPageTitle(`Organization Master`));
        fetchOrgList();
    }, [accessToken, dispatch])
    const fetchOrgList = (pageNo = 0) =>{
        dispatch(setMainLoading(true));
        let postData = {}
        if (pageNo > 0) {
            postData.page = pageNo
            postData.perPage = paginationData.per_page
        }
        PostAxios(`masters/organization`, postData, accessToken)
            .then(({ data }) => {
                console.log(data);
                if (data.status === "1") {
                    setPaginationData({ total: data.totalRecords, per_page: data.perPage });
                    setOrgList(data.data);
                }
                else{
                    setPaginationData({ total: 0, per_page: 20 });
                    setOrgList([]);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    return (
        <>
            <div className="main-form-sec">
                {/* <div className="top-right-btn p-0">
                    <button
                        className="btn-blue btn br-0"
                    >
                        Add New
                    </button>
                </div> */}
                <div className="table-wrapper">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Short Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                orgList.length > 0 && orgList.map((item,index)=>(
                                    <tr key={`org-id-${index}-${item.id}`}>
                                        <td>{item.org_name}</td>
                                        <td>{item.short_name}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default OrgMaster;